import {Member} from './Member';
import {Individual} from './Individual';

export enum Activity {
    ALL='ALL', ACTIVE='ACTIVE', INACTIVE='INACTIVE'
}

export class Group {
    id: number;
    name: string;
    device_name: string;
    group_type_id: number;
    group_type: string;
    notification_to_id: string;
    notification_to_type: string;
    escalate_to: string;
    escalate_to_id: string;
    escalate_to_type: string;
    escalate_time_limit: number;
    reminder_time_limit: number;
    ack_required: boolean;
    ack_required_percentage: number;
    sub_group_enabled: boolean;
    open_group: boolean;
    active: boolean;
    lastModifiedTime: number;
    owners: Individual[];
    members: Member[];

    constructor(source?: Group) {
        this.id = source && source.id || null;
        this.name = source && source.name || null;
        this.device_name = source && source.device_name || null;
        this.group_type_id = source && source.group_type_id || null;
        this.group_type = source && source.group_type || null;
        this.ack_required = source && source.ack_required || false;
        this.ack_required_percentage = source && source.ack_required_percentage || 1;
        this.notification_to_id = source && source.notification_to_id || null;
        this.notification_to_type = source && source.notification_to_type || null;
        this.escalate_to = source && source.escalate_to || 'Do Not Escalate';
        this.escalate_to_id = source && source.escalate_to_id || null;
        this.escalate_to_type = source && source.escalate_to_type || null;
        this.escalate_time_limit = source && source.escalate_time_limit || 0;
        this.reminder_time_limit = source && source.reminder_time_limit || 0;
        this.sub_group_enabled = source && source.sub_group_enabled || false;
        this.open_group = source && source.open_group || false;
        this.active = source && source.active;
        this.lastModifiedTime = source && source.lastModifiedTime || null;
        this.owners = source && source.owners || [];
        this.members = source && source.members || [];
    }

    generateDeviceName() {
        this.device_name = this.name == null ? null : this.name.replace(/ /g, '_').toUpperCase();
    }
}
